<script setup lang="ts">
import { ref } from 'vue'
import lx from '../../utils/lx'
import { LX_BIDS, type FaqItem } from './constants'

defineProps<{
  faqItems: FaqItem[]
}>()

/** 设计稿默认展开第一项 */
const activeKey = ref<string | number | Array<string | number>>('0')

function onQuestionClick(questionId: string): void {
  lx.moduleClick(LX_BIDS.faqMc, { module_identifier: questionId })
}
</script>

<template>
  <section id="faqSection" class="faq-section">
    <div class="faq-heading">
      <div class="faq-heading-accent">美团智播数字人</div>
      <div class="faq-heading-main">常见问题</div>
    </div>

    <div class="faq-panel">
      <mtd-collapse v-model="activeKey" class="faq-collapse" type="sample">
        <mtd-collapse-item
          v-for="(item, index) in faqItems"
          :key="item.question"
          :value="String(index)"
        >
          <template #title>
            <div
              class="faq-question"
              :data-mv-bid="LX_BIDS.faqMv"
              :data-mv-key="`faq-${index + 1}`"
              :data-mv-question-id="`${index + 1}`"
              @click="onQuestionClick(`${index + 1}`)"
            >
              <span>{{ item.question }}</span>
              <i class="mtdicon mtdicon-down-thick faq-arrow faq-arrow-down" aria-hidden="true" />
              <i class="mtdicon mtdicon-up-thick faq-arrow faq-arrow-up" aria-hidden="true" />
            </div>
          </template>
          <div class="faq-answer">{{ item.answer }}</div>
        </mtd-collapse-item>
      </mtd-collapse>
    </div>
  </section>
</template>

<style scoped lang="scss">
.faq-section {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 48px;
  width: 1200px;
  max-width: calc(100% - 48px);
  margin: 200px auto 0;
}

.faq-heading {
  flex: none;
  width: 336px;
}

.faq-heading-accent,
.faq-heading-main {
  font-size: 48px;
  font-weight: 700;
  line-height: normal;
}

.faq-heading-accent {
  margin-bottom: 12px;
  color: #8932ff;
}

.faq-heading-main {
  color: #171717;
}

/* 灰色盒子：#F7F7F7 / radius 24 / padding 32 */
.faq-panel {
  flex: 1;
  box-sizing: border-box;
  width: 639px;
  max-width: 639px;
  padding: 32px;
  border-radius: 24px;
  background: #f7f7f7;
}

.faq-collapse {
  width: 100%;
  border: 0 !important;
  background: transparent !important;
}

.faq-collapse :deep(.mtd-collapse-item) {
  border: 0 !important;
  background: transparent !important;
}

.faq-collapse :deep(.mtd-collapse-item-header) {
  height: auto !important;
  min-height: 24px;
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
  line-height: normal !important;
  white-space: normal !important;
}

.faq-collapse :deep(.mtd-collapse-arrow) {
  display: none !important;
}

.faq-collapse :deep(.mtd-collapse-item-content) {
  padding: 12px 0 0 !important;
  border: 0 !important;
  color: #666;
}

.faq-collapse :deep(.mtd-collapse-item-wrapper) {
  border-top: 0 !important;
  background: transparent !important;
}

.faq-collapse :deep(.mtd-collapse-item + .mtd-collapse-item) {
  margin-top: 10px;
  padding-top: 22px;
  border-top: 1px solid rgba(216, 216, 216, 0.5) !important;
}

.faq-question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  color: #171717;
  font-size: 20px;
  font-weight: 600; /* DB */
  line-height: normal;
}

.faq-arrow {
  flex: none;
  color: #757575;
  font-size: 16px;
  line-height: 1;
}

.faq-arrow-up {
  display: none;
}

.faq-collapse :deep(.mtd-collapse-item-active) .faq-arrow-down {
  display: none;
}

.faq-collapse :deep(.mtd-collapse-item-active) .faq-arrow-up {
  display: inline-block;
}

.faq-answer {
  max-width: 100%;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

@media (max-width: 960px) {
  .faq-section {
    flex-direction: column;
    width: auto;
    max-width: none;
    margin: 64px 20px 0;
    gap: 24px;
  }

  .faq-heading {
    width: auto;
  }

  .faq-heading-accent,
  .faq-heading-main {
    font-size: 28px;
  }

  .faq-panel {
    width: 100%;
    max-width: none;
    padding: 20px;
  }

  .faq-question {
    font-size: 16px;
  }
}
</style>
